import React, {useContext, useState} from 'react'
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import axios from "axios";
import {useHistory} from "react-router-dom";
import {UserContext} from "./UserContext";
import ViewTrip from "./ViewTrip";
import AppBar from "@mui/material/AppBar";
import {getBearerToken, getServerUrl} from "./utils/utils";

function Notifications({notifications, closeMenu, notificationResponses, setNotificationResponses, setSelectedTripId, setOpenTripModal }) {
    const {user, retrieveLatestTrips} = useContext(UserContext)
    let history = useHistory();

    const respondToTagRequest = async (tagRequestId, accepted) => {
        const updatedNotificationResponses = {...notificationResponses}
        updatedNotificationResponses[tagRequestId] = {
            accepted,
            type: 'TRIP'
        }
        setNotificationResponses(updatedNotificationResponses)
        axios.put(`${getServerUrl()}/tagUser/${tagRequestId}`, {
            accepted
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            },
        })
            .then(() => {
                retrieveLatestTrips()
            })
    }

    const respondToFriendRequest = async (friendId, accepted) => {
        const updatedNotificationResponses = {...notificationResponses}
        updatedNotificationResponses[friendId] = {
            accepted,
            type: 'FRIEND'
        }
        setNotificationResponses(updatedNotificationResponses)
        axios.post(`${getServerUrl()}/friends/${friendId}`, {
            accepted
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            },
        })
    }
    const displayNotifications = notifications?.map(notification => {
        if (notification.type === 'FRIEND') {
            return (
                <MenuItem key={notification.friend.id}>
                    <Card sx={{maxWidth: 345}}>
                        <CardHeader
                            avatar={
                                <Avatar sx={{width: 75, height: 75}}
                                        src={notification.friend.friend.profilePictureUrl}/>
                            }
                            title={notification.friend.friend.username}
                            subheader="Added you as a friend"
                            className={"friend-card"}
                        />
                        {!notificationResponses[notification.friend.id] && (
                            <ButtonGroup variant="contained" aria-label="Basic button group">
                                <Button color="success"
                                        onClick={() => respondToFriendRequest(notification.friend.id, true)}>Confirm</Button>
                                <Button color="error"
                                        onClick={() => respondToFriendRequest(notification.friend.id, false)}>Deny</Button>
                            </ButtonGroup>
                        )}
                        {(notificationResponses[notification.friend.id] && notificationResponses[notification.friend.id].accepted) && (
                            <Button variant="contained" onClick={() => {
                                history.push(`/profile/${notification.friend.friend.id}`)
                                closeMenu()
                            }}>View Profile</Button>
                        )}
                        {(notificationResponses[notification.friend.id] && !notificationResponses[notification.friend.id].accepted) && (
                            <p>You have rejected this request</p>
                        )}
                    </Card>
                </MenuItem>
            )
        } else {
            return (
                <MenuItem key={notification.taggedUser.trip.id} className="notification-menu-item">
                    <Card sx={{maxWidth: 345}}>
                        <CardHeader
                            avatar={
                                <Avatar sx={{width: 75, height: 75}}
                                        src={notification.taggedUser.trip.trip_profile_image}/>
                            }
                            title={`${notification.taggedUser.initiatorUser.username} tagged you in a trip`}
                            subheader={notification.taggedUser.trip.name + " - " + notification.taggedUser.trip.location}
                            className={"friend-card"}
                        />
                        {!notificationResponses[notification.taggedUser.id] && (
                            <ButtonGroup variant="contained" aria-label="Basic button group">
                                <Button color="success" onClick={() => respondToTagRequest(notification.taggedUser.id, true)}
                                >Confirm</Button>
                                <Button color="error" onClick={() => respondToTagRequest(notification.taggedUser.id, false)}
                                >Deny</Button>
                            </ButtonGroup>
                        )}
                        {(notificationResponses[notification.taggedUser.id] && notificationResponses[notification.taggedUser.id].accepted) && (
                            <Button variant="contained" onClick={() => {
                                setSelectedTripId(notification.taggedUser.trip.id)
                                setOpenTripModal()
                                closeMenu()
                            }}>View Trip</Button>
                        )}
                        {(notificationResponses[notification.taggedUser.id] && !notificationResponses[notification.taggedUser.id].accepted) && (
                            <p>You have rejected this request</p>
                        )}
                    </Card>
                </MenuItem>
            )
        }
    })

    return( <>
            {displayNotifications}
        </>
    );
}

export default Notifications;